import React, { useState, useEffect } from "react";

export default function TenantForm({ tenant, onSubmit, onCancel }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
  });

  useEffect(() => {
    if (tenant) {
      setForm({
        name: tenant.name || "",
        email: tenant.email || "",
      });
    } else {
      setForm({ name: "", email: "" });
    }
  }, [tenant]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof onSubmit !== "function") return;

    onSubmit(form);
  };

  return (
    <form className="admin-form" onSubmit={handleSubmit}>
      <label>
        Name
        <input
          placeholder="Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />
      </label>

      <label>
        Email
        <input
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />
      </label>

      <div className="admin-form-actions">
        <button className="admin-button admin-button-primary" type="submit">
          {tenant ? "Update" : "Add"}
        </button>

        <button className="admin-button admin-button-secondary" type="button" onClick={onCancel}>
          Cancel
        </button>
      </div>
    </form>
  );
}
